import DynamicContent from './DynamicContent'
export default DynamicContent
